import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Footer() {
    const { t } = useLanguage();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <span>© {currentYear} Lino. {t('footer.rights')}</span>
            <div className="footer-links">
                <Link to="/impressum">Impressum</Link>
                <Link to="/agb">AGB</Link>
                <Link to="/privacy">{t('footer.privacy')}</Link>
            </div>
        </footer>
    );
}
